import styled from '@emotion/styled'
import { Snackbar } from '@mui/material'

import { Space } from '../space'

type StyledToastBannerProps = {
  background: string
  border: string
}

export const StyledSnackbar = styled(Snackbar)`
  left: 240px !important;
`

export const StyledToast = styled(Space)<StyledToastBannerProps>`
  color: var(--White);
  background: ${props => props.background};
  border-radius: 4px;
  min-width: 325px;
`

export const StyledHeading = styled(Space)`
  font-size: ${props => props.theme?.fontSizes?.[2]}px;
`

export const StyledToastCloseIcon = styled(Space)`
  cursor: pointer;
`
